import mixpanel from "mixpanel-browser";
import React from "react";

import { getEnvironmentVariable } from "@/common/services/env";

type Props = {
  user: {
    id: string;
    name: string;
    email: string;
    phone?: string;
  };
  company?: {
    id: number;
    name?: string;
    country?: string;
    planId: string | number;
  };
};

const forceMixpanel = localStorage.getItem("forceMixpanel") === "true";

const Mixpanel = ({ user, company }: Props) => {
  if (forceMixpanel) {
    return <MixPanelImpl company={company} user={user} />;
  }

  if (user.email.endsWith("cleverfarm.ag")) {
    return <MixPanelNoop />;
  }

  return <MixPanelImpl company={company} user={user} />;
};

const MixPanelNoop = () => null;

const MixPanelImpl = ({ user, company }: Props) => {
  const mixpanelToken = getEnvironmentVariable("MIXPANEL_TOKEN");

  React.useEffect(() => {
    if (mixpanelToken) {
      mixpanel.init(mixpanelToken, {
        api_host: "https://api-eu.mixpanel.com",
        autocapture: false,
        record_sessions_percent: 100,
        track_pageview: false,
      });
    }
  }, [mixpanelToken]);

  React.useEffect(() => {
    mixpanel.identify(user.id);
    mixpanel.people.set({
      $email: user.email,
      $name: user.name,
      $phone: user.phone,
      company_country: company?.country,
      company_id: company?.id,
      company_name: company?.name,
      plan_id: company?.planId,
    });
  }, [user, company]);

  return null;
};

export { Mixpanel };
